module.exports = __webpack_public_path__ + "media/images/indicator-62aa9077caa98b93a45de15e463007ea.gif";